import React from 'react'
import { Footer, Header } from 'marketing-components'
import serverData from 'utils/server-data'

const { header, footer, isLoggedIn, isPrivacyHub } = serverData
let data
if (header && header.content) {
  const { contentLoggedOut, contentLoggedIn, config } = header.content
  data = { content: isLoggedIn ? contentLoggedIn : contentLoggedOut, config }
}

// eslint-disable-next-line camelcase
export default function Layout(props) {
  const directionality = serverData.locality.directionality
  return (
    <div style={{ direction: directionality }}>
      {isPrivacyHub ? <Header {...data} /> : ''}
      <>{props.children}</>
      {isPrivacyHub ? (
        <Footer content={footer && footer.content} config={ footer && footer.config} loggedIn={isLoggedIn} />
      ) : (
        ''
      )}
    </div>
  )
}
